import { useGetAllCampaignsApiV1Suspense } from "@/api/__generated__/api.schema";
import {
  type Campaign,
  CampaignAccessType,
  type CampaignCampaignStatus,
  type CampaignUserRegisterStatus,
} from "@/api/__generated__/models";
import type { CampaignIdType } from "@/constants/campaign";
import { useUser } from "@/hooks/auth/use-user";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";

interface CampaignsOptions {
  status?: CampaignCampaignStatus;
  registerStatus?: CampaignUserRegisterStatus;
}

export function useCampaigns({ status, registerStatus }: CampaignsOptions = {}) {
  const workspaceId = useWorkspaceId();
  const user = useUser();
  const {
    data: {
      data: { items },
    },
  } = useGetAllCampaignsApiV1Suspense(workspaceId);

  const filteredItems = items
    .filter((item) => checkCampaignStatus(item, status))
    .filter((item) => checkCampaignRegisterStatus(item, registerStatus))
    .filter((item) => checkCampaignAccessType(item, user.data?.email ?? ""));

  return { data: filteredItems };
}

function checkCampaignStatus(campaign: Campaign, status?: CampaignCampaignStatus) {
  if (status == null) {
    return true;
  }

  return campaign.campaignStatus === status;
}

function checkCampaignRegisterStatus(campaign: Campaign, registerStatus?: CampaignUserRegisterStatus) {
  if (registerStatus == null) {
    return true;
  }

  return campaign.userRegisterStatus === registerStatus;
}

function checkCampaignAccessType(campaign: Campaign, email: string) {
  if (campaign.accessType === CampaignAccessType.PUBLIC) {
    return true;
  }

  const allowedEmails = ALLOWED_EMAILS_BY_CAMPAIGN_ID[campaign.id as CampaignIdType];

  if (allowedEmails == null) {
    return true;
  }

  return allowedEmails.includes(email);
}

// TODO: Migrate to relation table - campaign_to_invite_email
const ALLOWED_EMAILS_BY_CAMPAIGN_ID: Record<CampaignIdType, string[] | null> = {
  // Benson Boone
  "3ae9c7ca-2121-4ea4-af1a-47a5fda4a61b": ["hello@backpac.app"],
  // Hanz Falling
  "7f854fc0-a36d-49b3-ad7a-046a06f82f66": null,
  // Mio Timeout
  "0f52a9ea-0a4d-424f-a89a-c691899286b0": null,
  // Hanz Best Friend
  "d4cb0a42-80bb-4600-b1d8-b1a0044c1cc8": ["hello@backpac.app"],
};
